import { safeDefine } from "../../registration/safe-define.js";
import { SliderThumbElement } from "../../ui/slider/thumb.js";
//#region src/define/ui/slider-thumb.ts
safeDefine(SliderThumbElement);
//#endregion

//# sourceMappingURL=slider-thumb.js.map